import { List, New, Edit } from "../Components/index";

export default [
    {
        path: "/admin/setting/move-order-approval-list",
        component: List,
        name: "setting.mo-approval-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/move-order-approval-new",
        component: New,
        name: "setting.mo-approval-new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/move-order-approval/:id/edit",
        component: Edit,
        name: "setting.mo-approval-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
